import { keyframes } from 'styled-components';
/** TODO: To be updated by NUIT-68 (Motion)
 *  This mixin contains various animation objects
 * @example
 * // styled-components usage
 * const example = styled.div
 * animation : popIn  //can be multiple animation objects
 * div {
 * animation: image, popIn }
 */

export var slideInFromLeft = keyframes(["0%{transform:translateX(-100%);}100%{transform:translateX(0);}"]);
export var slideInFromRight = keyframes(["0%{transform:translateX(100%);}100%{transform:translateX(0);}"]);
export var popIn = keyframes(["0%{transform:scale(0);opacity:0;}100%{transform:scale(1);opacity:1;}"]);
export var popOut = keyframes(["0%{transform:scale(1);opacity:1;}100%{transform:scale(0);opacity:0;}"]);
export var fadeIn = keyframes(["0%{transform:translateZ(-80px);opacity:0;}100%{transform:translateZ(0);opacity:1;}"]);
export var fadeOut = keyframes(["0%{transform:translateZ(0);opacity:1;}100%{transform:translateZ(-80px);opacity:0;}"]);
export var spin = keyframes(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
export var rotate = keyframes(["0%{transform:rotate(0);}100%{transform:rotate(180deg);}"]);
export var rotateReverse = keyframes(["0%{transform:rotate(180deg);}100%{transform:rotate(0);}"]);
export default slideInFromLeft;